<template>
  <p class="field" :class="{ 'invalid': error }">
    <label :for="name">
        {{ fullLabel }}
        <slot></slot>
    </label>
    <input
        type="text"
        size="30"
        class="datepicker app-datepicker"
        autocomplete="off"
        :id="name"
        :name="name"
        :value="value"
        :date-format="dateFormat"
        @input="$emit('updateDate', {date: $event.target.value, attrKey: name, item: item})"
        :disabled="disabled"
    />
    <span v-if="error" class="invalid_help">
        {{ error.msg }}
    </span>
  </p>
</template>

<script>

export default {
  name: 'app-datepicker',
  props: {
    name: {
      type: String,
      default: ''
    },
    attrKey: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    dateFormat: {
      type: String,
      default: 'dd. mm. yy'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: false
    },
    item: {
      type: Number,
      default: null
    }
  },
  computed: {
    fullLabel() {
      return this.required == true ? this.label + ' *' : this.label
    }
  },
  mounted: function () {
    $(this.$el).find('.datepicker').datepicker(this.getOptions())
  },
  beforeDestroy: function () {
    $(this.$el).find('.datepicker').datepicker('hide').datepicker('destroy')
  },
  methods: {
    getOptions() {
      const self = this
      return {
        dateFormat: this.dateFormat,
        onSelect: function (date) {
          self.$emit('updateDate', { date: date, attrKey: self.name })
        }
      }
    }
  }
}
</script>
